import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import Illustratie from '@/components/Kop/Kop.vue'

export default Node.create({
    name: 'Kop',

    group: 'block',
    content: 'inline*',

    addAttributes() {
        return {
            value: {
                default: "attr string"
            },
        }
    },

    parseHTML() {
        return [
            {
                tag: 'kop',
            },
        ]
    },

    renderHTML({ HTMLAttributes }) {
        return ['kop', mergeAttributes(HTMLAttributes)]
    },

    addNodeView() {
        return VueNodeViewRenderer(Illustratie)
    },
})